import { Fragment, useEffect, useRef } from "react";
import { splitMessageTime } from "../../ClientMessages/User/data";
import styles from "./ConversationBubbles.module.css";

export default function ConversationBubbles({ messages, className }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const t = setTimeout(() => {
      el.scrollTop = el.scrollHeight;
    }, 50);
    return () => clearTimeout(t);
  }, [messages]);

  let lastDay = "";

  return (
    <div
      ref={containerRef}
      className={`${styles.conversation} ${className || ""}`}
    >
      {messages.map((m, i) => {
        const { day, clock } = splitMessageTime(m.time);
        const showDaySep = day !== lastDay;
        lastDay = day;
        return (
          <Fragment key={i}>
            {showDaySep && <div className={styles.daySep}>{day}</div>}
            <div
              className={`${styles.bubbleGroup} ${m.outgoing ? styles.outgoing : ""}`}
            >
              <div
                className={`${styles.bubbleAvatar} ${m.outgoing ? styles.you : styles.sender}`}
              >
                {m.initials}
              </div>
              <div className={styles.bubbleContent}>
                <div className={styles.bubbleName}>{m.from}</div>
                <div className={styles.bubble}>{m.text}</div>
                <div className={styles.bubbleTime}>{clock}</div>
              </div>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
